import React, { useRef, useState } from 'react'
import { Modal } from 'antd';
import { YhForm } from '@src/components/YhFormBox';
import { globalPrompt } from '@src/components/YhMessage';
import { FormItemTypeEnum, IYhForm, IYhFormRef } from '@src/components/YhFormBox/Types';
import { IResetPwd } from '@src/views/authPortal/auth/user/UserTypes';
import { userService } from '@src/views/authPortal/auth/user/UserService';
import useGlobalModel from '@src/model/globalModel';

const ChangePass = () => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { user, changePassVisible, setChangePassVisible } = useGlobalModel();


  const handleCancel = () => {
    console.log('Clicked cancel button');
    setChangePassVisible(false);
  };
  const formRef = useRef<IYhFormRef>();

  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 6 },
    initialValues: {
      name: user.userName,
    },
    justify: 'start',
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "用户账号",
        fieldName: "name",
        disable: true,
        span: 24,
      }, {
        type: FormItemTypeEnum.Input,
        fieldLabel: "原始密码",
        fieldName: "pwd",
        span: 24,
      }, {
        type: FormItemTypeEnum.Password,
        fieldLabel: "新密码",
        fieldName: "newPwd",
        rules: [
          { required: true, message: "新密码为必填项！" }
        ],
        span: 24,
      }, {
        type: FormItemTypeEnum.Password,
        fieldLabel: "确认密码",
        fieldName: "repeatNewPwd",
        rules: [
          { required: true, message: "新密码为必填项！" },
          {
            validator: (rule, value, callback) => {
              try {
                let formData = formRef.current?.getFieldsValue()
                if (formData.newPwd === value) {
                  return callback()
                } else {
                  return callback("确认密码需要与新密码一致！")
                }
              } catch (error) {
                return callback(error)
              }
            }
          }
        ],
        span: 24,
      }
    ]
  };

  const onOk = async () => {
    try {
      setConfirmLoading(true);
      const formData = await formRef.current?.validateFields();
      setConfirmLoading(false);
      if (formData) {
        const params: IResetPwd = {
          newPwd: formData.newPwd,
          originalPwd: formData.pwd,
          repeatNewPwd: formData.repeatNewPwd,
          userCode: user.userCode,
          resetType: "USER_RESET",
        }
        const insertRet = await userService.resetPwd(params);
        if (insertRet.success) {
          await globalPrompt("message", { type: "success", text: '修改成功!' });
          setChangePassVisible(false);
        } else {
          await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
        }

      }
    } catch (e) {
      console.log("失败!");
    }
  }

  return (
    <Modal
      title="修改密码"
      visible={changePassVisible}
      onOk={onOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <YhForm  {...formConfig} />
    </Modal>
  );
};

export default ChangePass;